export enum GeolocationCodeError {
    'PermissionDenied' = 1,
    'PositionUnavailable' = 2,
    'Timeout' = 3
}
